// import React, { useState, useEffect, useContext } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { Plus, X, Save, ArrowLeft, Calendar, User, Building, Activity, Shield } from 'lucide-react';
// import AuthContext from '../../../../context/AuthContext';
// import { useToast } from '../../../../context/ToastContext';
// import useLoader from '../../../../context/useLoader';

// import processService from '../../../../services/processService';
// import activityService from '../../../../services/activityService';


// export default function EditCartograph() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const { authTokens } = useContext(AuthContext);
//   const { showSuccess, showError, showWarning } = useToast();
//   const { isLoading, showLoader, hideLoader } = useLoader();
  
//   const [formData, setFormData] = useState({
//     processName: '',
//     processDate: '',
//     controlElement: '',
//     focalPoint: '',
//     controlDate: '',
//     status: 'draft',
//     activities: [{ id: 1, activity: '', activityId: null }],
//     reductionActions: [{ id: 1, action: '', actionDate: '' }]
//   });

//   const [activitySuggestions, setActivitySuggestions] = useState([]);
//   const [filteredSuggestions, setFilteredSuggestions] = useState([]);
//   const [activeSuggestionIndex, setActiveSuggestionIndex] = useState({});
//   const [isSearching, setIsSearching] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

//   const statusOptions = ['draft', 'published', 'archived'];

//   // Fetch process data on mount
//   useEffect(() => {
//     fetchProcessData();
//   }, [id]);

//   // Track unsaved changes
//   useEffect(() => {
//     setHasUnsavedChanges(true);
//   }, [formData]);

//   const fetchProcessData = async () => {
//     showLoader('Chargement du processus...');
    
//     try {
//       const result = await processService.getProcessDetails(id, authTokens.access);
      
//       if (result.success) {
//         const process = result.data;
        
//         // Map the fetched data to form structure
//         setFormData({
//           processName: process.process_name || '',
//           processDate: process.process_date || '',
//           controlElement: process.element_to_controle || '',
//           focalPoint: process.focal_point || '',
//           controlDate: process.controleDate || '',
//           status: process.status || 'draft',
//           activities: process.associated_activities && process.associated_activities.length > 0
//             ? process.associated_activities.map((act, idx) => ({
//                 id: idx + 1,
//                 activity: act.activity_name || '',
//                 activityId: act.activity || null
//               }))
//             : [{ id: 1, activity: '', activityId: null }],
//           // reductionActions: process.reduction_actions_list && process.reduction_actions_list.length > 0
//           //   ? process.reduction_actions_list.map((action, idx) => ({
//           //       id: idx + 1,
//           //       action: action.action || '',
//           //       actionDate: action.actionDate || ''
//           //     }))
//           //   : [{ id: 1, action: '', actionDate: '' }]
//         });
        
//         setHasUnsavedChanges(false);
//       } else {
//         showError(`Erreur lors du chargement: ${result.error}`);
//         setTimeout(() => navigate(-1), 2000);
//       }
//     } catch (error) {
//       console.error('Error fetching process:', error);
//       showError('Impossible de charger le processus');
//       setTimeout(() => navigate(-1), 2000);
//     } finally {
//       hideLoader();
//     }
//   };

//   const handleInputChange = (field, value) => {
//     setFormData(prev => ({
//       ...prev,
//       [field]: value
//     }));
//   };

//   const handleActivityChange = async (index, value) => {
//     const updatedActivities = formData.activities.map((activity, i) => 
//       i === index ? { ...activity, activity: value, activityId: null } : activity
//     );
    
//     setFormData(prev => ({
//       ...prev,
//       activities: updatedActivities
//     }));

//     // Search activities using API
//     if (value.length > 2) {
//       setIsSearching(true);
//       try {
//         const result = await activityService.searchActivities(value, authTokens.access);
//         if (result.success) {
//           setActivitySuggestions(result.data);
//           setFilteredSuggestions(result.data);
//           setActiveSuggestionIndex({ [index]: true });
//         } else {
//           console.error('Failed to search activities:', result.error);
//           setFilteredSuggestions([]);
//         }
//       } catch (error) {
//         console.error('Error searching activities:', error);
//         setFilteredSuggestions([]);
//       } finally {
//         setIsSearching(false);
//       }
//     } else {
//       setFilteredSuggestions([]);
//       setActiveSuggestionIndex({});
//     }
//   };

//   const selectSuggestion = (index, activityObj) => {
//     const updatedActivities = formData.activities.map((activity, i) => 
//       i === index ? { 
//         ...activity, 
//         activity: activityObj.activity_name, 
//         activityId: activityObj.id 
//       } : activity
//     );
    
//     setFormData(prev => ({
//       ...prev,
//       activities: updatedActivities
//     }));
    
//     setFilteredSuggestions([]);
//     setActiveSuggestionIndex({});
//   };

//   const addActivity = () => {
//     const newActivity = {
//       id: formData.activities.length + 1,
//       activity: '',
//       activityId: null
//     };
//     setFormData(prev => ({
//       ...prev,
//       activities: [...prev.activities, newActivity]
//     }));
//   };

//   const removeActivity = (index) => {
//     if (formData.activities.length > 1) {
//       const updatedActivities = formData.activities.filter((_, i) => i !== index);
//       setFormData(prev => ({
//         ...prev,
//         activities: updatedActivities
//       }));
//     }
//   };



//   const handleSubmit = async () => {
//     // Validation
//     if (!formData.processName || !formData.processDate) {
//       showWarning('Veuillez remplir les champs obligatoires (Nom du processus et Date du processus)');
//       return;
//     }

//     setIsSubmitting(true);
//     showLoader('Mise à jour du processus...');
    
//     try {
//       // Prepare data for API
//       const processData = {
//         process_name: formData.processName,
//         process_date: formData.processDate,
//         element_to_controle: formData.controlElement,
//         focal_point: formData.focalPoint,
//         controleDate: formData.controlDate,
//         status: formData.status,
//         activities: formData.activities
//           .filter(activity => activity.activityId)
//           .map(activity => activity.activityId),
//       };

//       console.log('📡 Updating process data:', processData);

//       const result = await processService.editProcess(id, processData, authTokens.access);
      
//       if (result.success) {
//         showSuccess('Processus mis à jour avec succès!');
//         setHasUnsavedChanges(false);
        
//         // Navigate back after short delay
//         setTimeout(() => {
//           navigate(-1);
//         }, 1500);
//       } else {
//         showError(`Erreur lors de la mise à jour: ${result.error}`);
//         console.error('Process update failed:', result);
//       }
//     } catch (error) {
//       console.error('Error updating process:', error);
//       showError('Une erreur est survenue lors de la mise à jour du processus');
//     } finally {
//       hideLoader();
//       setIsSubmitting(false);
//     }
//   };

//   const handleCancel = () => {
//     if (hasUnsavedChanges) {
//       navigate(-1)      
//     } else {
//       navigate();
//     }
//   };

//   return (
//     <div className="max-w-4xl mx-auto space-y-6">
//       {/* Header */}
//       <div className="flex items-center justify-between">
//         <div className="flex items-center space-x-4">
//           <button 
//             onClick={handleCancel}
//             className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
//             disabled={isLoading}
//           >
//             <ArrowLeft className="h-5 w-5 text-gray-500" />
//           </button>
//           <h2 className="text-2xl font-bold text-gray-900">Modifier la Cartographie</h2>
//         </div>
//         {hasUnsavedChanges && (
//           <span className="text-sm text-amber-600 font-medium">
//             Modifications non sauvegardées
//           </span>
//         )}
//       </div>

//       <div className="space-y-8">
//         {/* Process Information Section */}
//         <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm">
//           <div className="flex items-center mb-6">
//             <Building className="h-5 w-5 text-teal-600 mr-2" />
//             <h3 className="text-lg font-semibold text-gray-900">Informations du Processus</h3>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Nom du Processus *
//               </label>
//               <input
//                 type="text"
//                 value={formData.processName}
//                 onChange={(e) => handleInputChange('processName', e.target.value)}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
//                 placeholder="Entrez le nom du processus"
//                 required
//                 disabled={isLoading}
//               />
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Date du Processus *
//               </label>
//               <div className="relative">
//                 <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
//                 <input
//                   type="date"
//                   value={formData.processDate}
//                   onChange={(e) => handleInputChange('processDate', e.target.value)}
//                   className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
//                   required
//                   disabled={isLoading}
//                 />
//               </div>
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Élément à Contrôler
//               </label>
//               <input
//                 type="text"
//                 value={formData.controlElement}
//                 onChange={(e) => handleInputChange('controlElement', e.target.value)}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
//                 placeholder="Élément à contrôler"
//                 disabled={isLoading}
//               />
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Point Focal
//               </label>
//               <div className="relative">
//                 <User className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
//                 <input
//                   type="text"
//                   value={formData.focalPoint}
//                   onChange={(e) => handleInputChange('focalPoint', e.target.value)}
//                   className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
//                   placeholder="Nom du point focal"
//                   disabled={isLoading}
//                 />
//               </div>
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Date de Contrôle
//               </label>
//               <div className="relative">
//                 <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
//                 <input
//                   type="date"
//                   value={formData.controlDate}
//                   onChange={(e) => handleInputChange('controlDate', e.target.value)}
//                   className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
//                   disabled={isLoading}
//                 />
//               </div>
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Statut
//               </label>
//               <select
//                 value={formData.status}
//                 onChange={(e) => handleInputChange('status', e.target.value)}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
//                 disabled={isLoading}
//               >
//                 {statusOptions.map(option => (
//                   <option key={option} value={option}>{option}</option>
//                 ))}
//               </select>
//             </div>
//           </div>
//         </div>

//         {/* Activities Section */}
//         <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm">
//           <div className="flex items-center justify-between mb-6">
//             <div className="flex items-center">
//               <Activity className="h-5 w-5 text-blue-600 mr-2" />
//               <h3 className="text-lg font-semibold text-gray-900">Activités du Processus</h3>
//             </div>
//             <button
//               type="button"
//               onClick={addActivity}
//               className="flex items-center px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors disabled:opacity-50"
//               disabled={isLoading}
//             >
//               <Plus className="h-4 w-4 mr-2" />
//               Ajouter Activité
//             </button>
//           </div>

//           <div className="space-y-4">
//             {formData.activities.map((activity, index) => (
//               <div key={activity.id} className="flex items-center space-x-4">
//                 <div className="flex-1 relative">
//                   <input
//                     type="text"
//                     value={activity.activity}
//                     onChange={(e) => handleActivityChange(index, e.target.value)}
//                     className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                     placeholder={`Activité ${index + 1}`}
//                     disabled={isLoading}
//                   />
                  
//                   {/* Suggestions dropdown */}
//                   {activeSuggestionIndex[index] && filteredSuggestions.length > 0 && (
//                     <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg max-h-48 overflow-y-auto">
//                       {isSearching ? (
//                         <div className="px-3 py-2 text-gray-500">Recherche en cours...</div>
//                       ) : (
//                         filteredSuggestions.map((activityObj, suggestionIndex) => (
//                           <button
//                             key={suggestionIndex}
//                             type="button"
//                             onClick={() => selectSuggestion(index, activityObj)}
//                             className="w-full text-left px-3 py-2 hover:bg-gray-50 focus:bg-gray-50 focus:outline-none"
//                           >
//                             <div className="font-medium">{activityObj.activity_name}</div>
//                             {activityObj.description && (
//                               <div className="text-sm text-gray-500 truncate">{activityObj.description}</div>
//                             )}
//                           </button>
//                         ))
//                       )}
//                     </div>
//                   )}
//                 </div>
                
//                 {formData.activities.length > 1 && (
//                   <button
//                     type="button"
//                     onClick={() => removeActivity(index)}
//                     className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors disabled:opacity-50"
//                     disabled={isLoading}
//                   >
//                     <X className="h-4 w-4" />
//                   </button>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>



//         {/* Form Actions */}
//         <div className="flex justify-end space-x-4 pt-6">
//           <button
//             type="button"
//             onClick={handleCancel}
//             className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50"
//             disabled={isLoading || isSubmitting}
//           >
//             Annuler
//           </button>
//           <button
//             type="button"
//             onClick={handleSubmit}
//             disabled={isLoading || isSubmitting}
//             className="flex items-center px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//           >
//             <Save className="h-4 w-4 mr-2" />
//             {isSubmitting ? 'Mise à jour...' : 'Sauvegarder'}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }



import React, { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Plus, X, Save, ArrowLeft, Calendar, User, Building, Activity, Shield } from 'lucide-react';
import AuthContext from '../../../../context/AuthContext';
import { useToast } from '../../../../context/ToastContext';
import useLoader from '../../../../context/useLoader';

import processService from '../../../../services/processService';
import activityService from '../../../../services/activityService';


export default function EditCartograph() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { authTokens } = useContext(AuthContext);
  const { showSuccess, showError, showWarning } = useToast();
  const { isLoading, showLoader, hideLoader } = useLoader();
  
  const [formData, setFormData] = useState({
    processName: '',
    processDate: '',
    focalPoint: '',
    status: 'draft',
    controlElements: [{ id: 1, element: '', controlDate: '' }],
    activities: [{ id: 1, activity: '', activityId: null }],
  });

  const [activitySuggestions, setActivitySuggestions] = useState([]);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [activeSuggestionIndex, setActiveSuggestionIndex] = useState({});
  const [isSearching, setIsSearching] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const statusOptions = ['draft', 'published', 'archived'];

  // Fetch process data on mount
  useEffect(() => {
    fetchProcessData();
  }, [id]);

  // Track unsaved changes
  useEffect(() => {
    setHasUnsavedChanges(true);
  }, [formData]);

  const fetchProcessData = async () => {
    showLoader('Chargement du processus...');
    
    try {
      const result = await processService.getProcessDetails(id, authTokens.access);
      
      if (result.success) {
        const process = result.data;
        
        // Map the fetched data to form structure
        setFormData({
          processName: process.process_name || '',
          processDate: process.process_date || '',
          focalPoint: process.focal_point || '',
          status: process.status || 'draft',
          controlElements: process.control_elements_list && process.control_elements_list.length > 0
              ? process.control_elements_list.map((element, idx) => ({
                  id: element.id || idx + 1,
                  element: element.element_name || '',
                  controlDate: element.control_date || ''
                }))
              : [{ id: 1, element: '', controlDate: '' }],
          activities: process.associated_activities && process.associated_activities.length > 0
            ? process.associated_activities.map((act, idx) => ({
                id: idx + 1,
                activity: act.activity_name || '',
                activityId: act.activity || null
              }))
            : [{ id: 1, activity: '', activityId: null }],
        });
        
        setHasUnsavedChanges(false);
      } else {
        showError(`Erreur lors du chargement: ${result.error}`);
        setTimeout(() => navigate(-1), 2000);
      }
    } catch (error) {
      console.error('Error fetching process:', error);
      showError('Impossible de charger le processus');
      setTimeout(() => navigate(-1), 2000);
    } finally {
      hideLoader();
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Control Elements handlers
  const handleControlElementChange = (index, field, value) => {
    const updatedElements = formData.controlElements.map((element, i) => 
      i === index ? { ...element, [field]: value } : element
    );
    
    setFormData(prev => ({
      ...prev,
      controlElements: updatedElements
    }));
  };

  const addControlElement = () => {
    const newElement = {
      id: formData.controlElements.length + 1,
      element: '',
      controlDate: ''
    };
    setFormData(prev => ({
      ...prev,
      controlElements: [...prev.controlElements, newElement]
    }));
  };

  const removeControlElement = (index) => {
    if (formData.controlElements.length > 1) {
      const updatedElements = formData.controlElements.filter((_, i) => i !== index);
      setFormData(prev => ({
        ...prev,
        controlElements: updatedElements
      }));
    }
  };

  // Activity handlers
  const handleActivityChange = async (index, value) => {
    const updatedActivities = formData.activities.map((activity, i) => 
      i === index ? { ...activity, activity: value, activityId: null } : activity
    );
    
    setFormData(prev => ({
      ...prev,
      activities: updatedActivities
    }));

    // Search activities using API
    if (value.length > 2) {
      setIsSearching(true);
      try {
        const result = await activityService.searchActivities(value, authTokens.access);
        if (result.success) {
          setActivitySuggestions(result.data);
          setFilteredSuggestions(result.data);
          setActiveSuggestionIndex({ [index]: true });
        } else {
          console.error('Failed to search activities:', result.error);
          setFilteredSuggestions([]);
        }
      } catch (error) {
        console.error('Error searching activities:', error);
        setFilteredSuggestions([]);
      } finally {
        setIsSearching(false);
      }
    } else {
      setFilteredSuggestions([]);
      setActiveSuggestionIndex({});
    }
  };

  const selectSuggestion = (index, activityObj) => {
    const updatedActivities = formData.activities.map((activity, i) => 
      i === index ? { 
        ...activity, 
        activity: activityObj.activity_name, 
        activityId: activityObj.id 
      } : activity
    );
    
    setFormData(prev => ({
      ...prev,
      activities: updatedActivities
    }));
    
    setFilteredSuggestions([]);
    setActiveSuggestionIndex({});
  };

  const addActivity = () => {
    const newActivity = {
      id: formData.activities.length + 1,
      activity: '',
      activityId: null
    };
    setFormData(prev => ({
      ...prev,
      activities: [...prev.activities, newActivity]
    }));
  };

  const removeActivity = (index) => {
    if (formData.activities.length > 1) {
      const updatedActivities = formData.activities.filter((_, i) => i !== index);
      setFormData(prev => ({
        ...prev,
        activities: updatedActivities
      }));
    }
  };

  const handleSubmit = async () => {
    // Validation
    if (!formData.processName || !formData.processDate) {
      showWarning('Veuillez remplir les champs obligatoires (Nom du processus et Date du processus)');
      return;
    }

    setIsSubmitting(true);
    showLoader('Mise à jour du processus...');
    
    try {
      // Prepare data for API
      const processData = {
        process_name: formData.processName,
        process_date: formData.processDate,
        focal_point: formData.focalPoint,
        status: formData.status,
        control_elements: formData.controlElements
          .filter(el => el.element.trim() !== '')
          .map(el => ({
            element_name: el.element,
            control_date: el.controlDate
          })),

        activities: formData.activities
          .filter(activity => activity.activityId)
          .map(activity => activity.activityId),
      };

      console.log('📡 Updating process data:', processData);

      const result = await processService.editProcess(id, processData, authTokens.access);
      
      if (result.success) {
        showSuccess('Processus mis à jour avec succès!');
        setHasUnsavedChanges(false);
        
        // Navigate back after short delay
        setTimeout(() => {
          navigate(-1);
        }, 1500);
      } else {
        showError(`Erreur lors de la mise à jour: ${result.error}`);
        console.error('Process update failed:', result);
      }
    } catch (error) {
      console.error('Error updating process:', error);
      showError('Une erreur est survenue lors de la mise à jour du processus');
    } finally {
      hideLoader();
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    if (hasUnsavedChanges) {
      navigate(-1);      
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <button 
            onClick={handleCancel}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            disabled={isLoading}
          >
            <ArrowLeft className="h-5 w-5 text-gray-500" />
          </button>
          <h2 className="text-2xl font-bold text-gray-900">Modifier la Cartographie</h2>
        </div>
        {hasUnsavedChanges && (
          <span className="text-sm text-amber-600 font-medium">
            Modifications non sauvegardées
          </span>
        )}
      </div>

      <div className="space-y-8">
        {/* Process Information Section */}
        <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm">
          <div className="flex items-center mb-6">
            <Building className="h-5 w-5 text-teal-600 mr-2" />
            <h3 className="text-lg font-semibold text-gray-900">Informations du Processus</h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Nom du Processus *
              </label>
              <input
                type="text"
                value={formData.processName}
                onChange={(e) => handleInputChange('processName', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                placeholder="Entrez le nom du processus"
                required
                disabled={isLoading}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Date du Processus *
              </label>
              <div className="relative">
                <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                <input
                  type="date"
                  value={formData.processDate}
                  onChange={(e) => handleInputChange('processDate', e.target.value)}
                  className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Point Focal
              </label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                <input
                  type="text"
                  value={formData.focalPoint}
                  onChange={(e) => handleInputChange('focalPoint', e.target.value)}
                  className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                  placeholder="Nom du point focal"
                  disabled={isLoading}
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Statut
              </label>
              <select
                value={formData.status}
                onChange={(e) => handleInputChange('status', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                disabled={isLoading}
              >
                {statusOptions.map(option => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Control Elements Section */}
        <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center">
              <Shield className="h-5 w-5 text-green-600 mr-2" />
              <h3 className="text-lg font-semibold text-gray-900">Éléments à Contrôler</h3>
            </div>
            <button
              type="button"
              onClick={addControlElement}
              className="flex items-center px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors disabled:opacity-50"
              disabled={isLoading}
            >
              <Plus className="h-4 w-4 mr-2" />
              Ajouter Élément
            </button>
          </div>

          <div className="space-y-4">
            {formData.controlElements.map((element, index) => (
              <div key={element.id} className="flex items-start space-x-4">
                <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <input
                      type="text"
                      value={element.element}
                      onChange={(e) => handleControlElementChange(index, 'element', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                      placeholder="Nom de l'élément à contrôler"
                      disabled={isLoading}
                    />
                  </div>
                  <div className="relative">
                    <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                    <input
                      type="date"
                      value={element.controlDate}
                      onChange={(e) => handleControlElementChange(index, 'controlDate', e.target.value)}
                      className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                      placeholder="Date de contrôle"
                      disabled={isLoading}
                    />
                  </div>
                </div>
                
                {formData.controlElements.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removeControlElement(index)}
                    className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors mt-0.5 disabled:opacity-50"
                    disabled={isLoading}
                  >
                    <X className="h-4 w-4" />
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Activities Section */}
        <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center">
              <Activity className="h-5 w-5 text-blue-600 mr-2" />
              <h3 className="text-lg font-semibold text-gray-900">Activités du Processus</h3>
            </div>
            <button
              type="button"
              onClick={addActivity}
              className="flex items-center px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors disabled:opacity-50"
              disabled={isLoading}
            >
              <Plus className="h-4 w-4 mr-2" />
              Ajouter Activité
            </button>
          </div>

          <div className="space-y-4">
            {formData.activities.map((activity, index) => (
              <div key={activity.id} className="flex items-center space-x-4">
                <div className="flex-1 relative">
                  <input
                    type="text"
                    value={activity.activity}
                    onChange={(e) => handleActivityChange(index, e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Rechercher une activité (min 3 caractères)"
                    disabled={isLoading}
                  />
                  
                  {/* Suggestions dropdown */}
                  {activeSuggestionIndex[index] && filteredSuggestions.length > 0 && (
                    <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg max-h-48 overflow-y-auto">
                      {isSearching ? (
                        <div className="px-3 py-2 text-gray-500">Recherche en cours...</div>
                      ) : (
                        filteredSuggestions.map((activityObj, suggestionIndex) => (
                          <button
                            key={suggestionIndex}
                            type="button"
                            onClick={() => selectSuggestion(index, activityObj)}
                            className="w-full text-left px-3 py-2 hover:bg-gray-50 focus:bg-gray-50 focus:outline-none"
                          >
                            <div className="font-medium">{activityObj.activity_name}</div>
                            {activityObj.description && (
                              <div className="text-sm text-gray-500 truncate">{activityObj.description}</div>
                            )}
                          </button>
                        ))
                      )}
                    </div>
                  )}
                </div>
                
                {formData.activities.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removeActivity(index)}
                    className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors disabled:opacity-50"
                    disabled={isLoading}
                  >
                    <X className="h-4 w-4" />
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Form Actions */}
        <div className="flex justify-end space-x-4 pt-6">
          <button
            type="button"
            onClick={handleCancel}
            className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50"
            disabled={isLoading || isSubmitting}
          >
            Annuler
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={isLoading || isSubmitting}
            className="flex items-center px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <Save className="h-4 w-4 mr-2" />
            {isSubmitting ? 'Mise à jour...' : 'Sauvegarder'}
          </button>
        </div>
      </div>
    </div>
  );
}